import styled from "styled-components";
export const InvalidCriteriaMessage = styled.div.withConfig({
  displayName: "InvalidCriteriaMessage",
  componentId: "sc-uh2dj0-0"
})(["padding-top:1px;font-size:smaller;color:red;width:100%;text-align:center;"]);